<template>
  <div class="sku-img-tag">
    <template v-for="(item, index) in tagMap">
      <template v-if="!item.showTag"></template>
      <div
        v-else-if="item.tagTitle === 'centerTag'"
        :key="index"
        :class="['stock-wrap', item.tag.mantle ? 'mask' : '']"
      >
        <div class="text-wrap">
          <img
            v-if="item.tag.tagImg"
            :src="item.tag.tagImg"
            :style="customImagStyle"
          />
          <Tag
            v-else
            :has-border="!!item.tag.frameColor"
            :has-background="!!item.tag.backgroundColor"
            :primary-color="item.tag.textColor"
            :secondary-color="item.tag.frameColor"
            :corner-radius="item.tag.cornerRadius"
            :bg-color="item.tag.backgroundColor"
            :font-size="item.tag.textSize"
            :padding="
              !item.tag.backgroundColor || !item.tag.frameColor ? 4 : undefined
            "
            :has-margin="false"
          >
            {{ item.tag.tag }}
          </Tag>
        </div>
      </div>
      <div
        v-else-if="item.tagTitle === 'leftUpperMultiTag'"
        :key="index + 'leftUpperMultiTag'"
        class="left-multi-wrapper"
      >
        <img
          v-for="tagItem in item.tag"
          :key="tagItem.tagType"
          :src="tagItem.tagImg"
          class="left-multi-img"
        />
      </div>

      <template v-else>
        <div :key="index">
          <img
            v-if="item.tag.tagImg"
            :src="item.tag.tagImg"
            :class="`ssu-${item.tagTitle}-img`"
            :style="customImagStyle"
          />
          <Tag
            v-else
            :has-border="!!item.tag.frameColor"
            :has-background="!!item.tag.backgroundColor"
            :primary-color="item.tag.textColor"
            :secondary-color="item.tag.frameColor"
            :corner-radius="item.tag.cornerRadius"
            :bg-color="item.tag.backgroundColor"
            :font-size="item.tag.textSize"
            :padding="
              !item.tag.backgroundColor || !item.tag.frameColor ? 4 : undefined
            "
            :has-margin="false"
            :class="[
              `ssu-${item.tagTitle}-tag`,
              !!item.tag.fullLay ? 'full-lay' : ''
            ]"
            :text-ellipsis="!!item.tag.fullLay"
            :use-trans-scale="!item.tag.fullLay"
          >
            {{ item.tag.tag }}
          </Tag>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import Tag from '@/common/widgets/good_tag'
export default {
  components: {
    Tag
  },
  props: {
    skuImg: {
      type: Object,
      default: () => {}
    },
    customImagStyle: {
      type: Object,
      default: () => {}
    },
    width: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      tagMap: []
    }
  },

  created() {
    const leftUpperTag =
      this?.skuImg?.leftUpperTag && this?.skuImg?.leftUpperTag.length > 0
        ? this?.skuImg.leftUpperTag[0]
        : {}

    const showLeftUpperTag = Object.keys(leftUpperTag).length > 0

    const leftUpperMultiTag =
      this?.skuImg?.leftUpperMultiTag &&
      this?.skuImg?.leftUpperMultiTag?.length > 0
        ? this?.skuImg.leftUpperMultiTag
        : []
    const showLeftMultiTag = leftUpperMultiTag.length > 0
    const leftBottomTag =
      this?.skuImg?.leftBottomTag && this?.skuImg?.leftBottomTag.length > 0
        ? this.skuImg.leftBottomTag
        : []

    const newLeftBottomTag =
      leftBottomTag.filter?.(item => !item.remainTime) || {}
    const newLeftBottomTagMap = newLeftBottomTag?.[0] || {}
    const showLeftBottomTag = Object.keys(newLeftBottomTagMap).length > 0
    const rightUpperTag =
      this?.skuImg?.rightUpperTag && this?.skuImg?.rightUpperTag.length > 0
        ? this.skuImg.rightUpperTag[0]
        : {}
    const showRightUpperTag = Object.keys(rightUpperTag).length > 0
    const rightBottomTag =
      this?.skuImg?.rightBottomTag && this?.skuImg?.rightBottomTag.length > 0
        ? this.skuImg.rightBottomTag[0]
        : {}
    const showRightBottomTag = Object.keys(rightBottomTag).length > 1
    const centerTag =
      this?.skuImg?.centerTag && Object.keys(this?.skuImg?.centerTag).length > 0
        ? this.skuImg.centerTag
        : {}
    const showCenterTag = Object.keys(centerTag).length > 0
    const tagMap = [
      {
        tag: leftUpperTag,
        showTag: showLeftUpperTag,
        tagTitle: 'leftUpperTag'
      },
      {
        tag: leftUpperMultiTag,
        showTag: showLeftMultiTag,
        tagTitle: 'leftUpperMultiTag'
      },
      {
        tag: newLeftBottomTagMap,
        showTag: showLeftBottomTag,
        tagTitle: 'leftBottomTag'
      },
      {
        tag: rightUpperTag,
        showTag: showRightUpperTag,
        tagTitle: 'rightUpperTag'
      },
      {
        tag: rightBottomTag,
        showTag: showRightBottomTag,
        tagTitle: 'rightBottomTag'
      },
      { tag: centerTag, showTag: showCenterTag, tagTitle: 'centerTag' }
    ]
    this.tagMap = tagMap
  }
}
</script>
<style lang="scss" scoped>
// .sku-img-tag {
//   width: 100%;
//   height: 100%;
// }
.ssu-leftUpperTag {
  &-tag {
    position: absolute;
    top: 0.04rem;
    left: 0.04rem;
  }
  &-img {
    width: 1.08rem /* 54/50 */;
    height: 1.08rem /* 54/50 */;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.ssu-leftBottomTag {
  &-tag {
    position: absolute;
    bottom: 0.04rem;
    left: 0.04rem;
    &.full-lay {
      width: 100%;
      height: 25px;
      left: 0;
      bottom: 0;
      @include text-overflow-ellipsis;
      @include flex-row-center;
    }
  }
  &-img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 1.08rem /* 54/50 */;
    height: 1.08rem /* 54/50 */;
  }
}
.ssu-rightUpperTag {
  &-tag {
    position: absolute;
    top: 0.04rem;
    right: 0.04rem;
  }
  &-img {
    position: absolute;
    top: 0;
    right: 0;
    width: 1.08rem /* 54/50 */;
    height: 1.08rem /* 54/50 */;
  }
}
.ssu-rightBottomTag {
  &-tag {
    position: absolute;
    right: 0.04rem;
    bottom: 0.04rem;
  }
  &-img {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 1.08rem /* 54/50 */;
    height: 1.08rem /* 54/50 */;
  }
}
.ssu-centerTag {
  &-tag {
    position: absolute;
  }
  &-img {
    position: absolute;
  }
}
.stock-wrap {
  position: absolute;
  top: 0;

  width: 101%;
  height: 101%;

  .text-wrap {
    display: flex;

    width: 100%;
    height: 100%;

    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.mask {
  background-color: rgba($color: #fff, $alpha: 0.6);
}
.left-multi-wrapper {
  position: absolute;
  left: 0.04rem;
  top: 0.04rem;
  display: flex;
  .left-multi-img {
    width: auto;
    height: 0.28rem /* 14/50 */;
    margin-right: 0.04rem /* 2/50 */;
    display: block;
    font-size: 0;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
